import { render, staticRenderFns } from "./AdvertisingPlatform.vue?vue&type=template&id=25a8c930&scoped=true"
import script from "./AdvertisingPlatform.vue?vue&type=script&lang=js"
export * from "./AdvertisingPlatform.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingPlatform.vue?vue&type=style&index=0&id=25a8c930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a8c930",
  null
  
)

export default component.exports